import Dialog from '@material-ui/core/Dialog';
import t from '../helpers/t';
// @ts-ignore
import {moment} from "../../../vendor";

const ChangeLogsDialog = ({
                                      handleCloseDialog,
                                      toggleChangeLogs,
                                      changeLogs
                                  }:any) => {
    // get all changelogs
    const changelogs = changeLogs ? changeLogs : [];
    let changelogInfoArr:any = [];
    if(changelogs !== null && changelogs?.length > 0){
        changelogs.map((changelog:any) => {
            changelogInfoArr.push({
                field: changelog.field,
                value: t(changelog.value),
                user: changelog.user,
                userId: changelog.user_id,
                date: moment(changelog.created).format('DD.MM.YYYY HH:mm:ss')
            })
        })
    }

    return (
        <Dialog
            onClose={handleCloseDialog}
            aria-labelledby="changelogs-dialog-title"
            open={toggleChangeLogs}
           // name = "changeLogsDialog"
            id = "changeLogsDialog"
            maxWidth={"md"}
        >
            <header className="inb-changelogs-header">

                    <button
                        onClick={handleCloseDialog}
                        type="button"
                        id="inb-changelogs-dialog-close-button"
                        className="button hollow secondary right button-close-changelogs-dialog round"
                        title={t("close changelogs dialog")}
                    >
                        <i className="fi fi-x"></i>
                    </button>

                {changelogInfoArr.length > 0 &&
                    <div id="inb-c-main-header">
                        <ul className="inb-tabs row">
                            <li className="tabs-title column medium-3">{t('date')}</li>
                            <li className="tabs-title column medium-4">{t('user')}</li>
                            <li className="tabs-title column medium-2">{t('field')}</li>
                            <li className="tabs-title column medium-3">{t('value')}</li>
                        </ul>
                    </div>
                }
            </header>
            <div id="inb-c-main-changelogs" className="inb-c-listing off-canvas-content" data-off-canvas-content="">
                <>
                    {changelogInfoArr.length > 0 ? changelogInfoArr.map((changelog:any, index:any) => {
                            return (
                                <div className="inb-c-item inb-c-item--changelog row" key={index}>
                                    <div className="medium-3 small-12 column value" title={t('date',null,'capital')} style={{minWidth:'40px', cursor: 'pointer'}} >
                                        <span>{changelog.date}</span>
                                    </div>
                                    <div className="medium-4 small-12 column" title={t('user',null,'capital')} style={{minWidth:'90px'}}>
                                        <a href={`/users/${changelog.userId}`}>{changelog.user}</a>
                                    </div>
                                    <div className="medium-2 small-12 column field" title={t('field',null,'capital')} style={{minWidth:'50px'}}>
                                        <span>{t(changelog.field)}</span>
                                    </div>
                                    <div className="medium-3 small-12 column value" title={t('value',null,'capital')} style={{minWidth:'90px', cursor: 'pointer'}} >
                                        <span>{t(changelog.value)}</span>
                                    </div>
                                </div>
                            )
                        })
                        :
                        <div className="no-user-item">
                            <div className="inb-image-box">
                                <img src="assets/img/no-user.png" />
                            </div>
                            <h3>{t("no changelog found")}</h3>
                        </div>
                    }
                </>
            </div>
        </Dialog>
    );
};

export default ChangeLogsDialog;
